import { render, staticRenderFns } from "./TreeChart.vue?vue&type=template&id=4fd45120&scoped=true"
import script from "./TreeChart.vue?vue&type=script&lang=js"
export * from "./TreeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd45120",
  null
  
)

export default component.exports